import { currentBibleClassAnnouncements } from "../slides/currentBibleClassAnnouncements";
import { slideGospelMeeting } from "../slides/gospelMeeting/slideGospelMeeting";
import { getInformer } from "../slides/informer";
import { slideMap } from "../slides/map/slideMap";
import { restingSlide } from "../slides/restingSlide";
import { slideGuestSpeakers } from "../slides/slideGuestSpeaker";
import { slideStandStrongPodcast } from "../slides/slideStandStrongPodcast";
import { slideWebsite } from "../slides/website";
import { slideWelcome } from "../slides/welcome";
import { slideWorshipPointer } from "../slides/worshipPointer";
import { slideWorshipTimes } from "../slides/worshipTimes";
import { upcomingBibleClassAnnouncements } from "../slides/upcomingBibleClassAnnouncements";
import { slideDirectory } from "../slides/directory";
import { slideGospelMeetingTEMP } from "../slides/gospelMeeting/slideGospelMeetingTemp";
export const slides = {
    [0 /* SlideIndex.Resting */]: restingSlide,
    [1 /* SlideIndex.Map */]: slideMap,
    [2 /* SlideIndex.LogoOnlyStart */]: slideWelcome(),
    [3 /* SlideIndex.Welcome */]: slideWelcome('<img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/welcome.svg" alt="Welcome!" />'),
    [4 /* SlideIndex.ThankYou */]: slideWelcome('<img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/thanks.svg" alt="Thank you for coming!" />'),
    [5 /* SlideIndex.StandStrongPodcast */]: slideStandStrongPodcast,
    [6 /* SlideIndex.GuestSpeakers */]: slideGuestSpeakers,
    [7 /* SlideIndex.GospelMeeting */]: slideGospelMeeting,
    [8 /* SlideIndex.GospelMeetingTemp */]: slideGospelMeetingTEMP,
    [9 /* SlideIndex.Informer */]: getInformer,
    [10 /* SlideIndex.Members */]: slideDirectory,
    [11 /* SlideIndex.Website */]: slideWebsite,
    [12 /* SlideIndex.WorshipTimes */]: slideWorshipTimes,
    [13 /* SlideIndex.WorshipPointer */]: slideWorshipPointer,
    [14 /* SlideIndex.UpcomingBibleClassAnnouncements */]: upcomingBibleClassAnnouncements,
    [15 /* SlideIndex.CurrentBibleClassAnnouncements */]: currentBibleClassAnnouncements,
};
